export default __webpack_public_path__ + "static/media/velatorio.afdac4c9.svg";